import React, { useState, useEffect } from "react";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
import FloatingButton from "./FloatingButton";

export default function ChatWindow() {
  // Get the #root element
  const rootElement = document.getElementById("bf-shopping-assistant");

  // State to manage the visibility of the chat window
  const [isChatVisible, setIsChatVisible] = useState(null);

  // State to manage which screen is currently shown
  const [currentScreen, setCurrentScreen] = useState(1);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [marketProductCode, setMarketProductCode] = useState(
    rootElement.getAttribute("data-market-product-code") || null
  );
  // Convert the attribute values to boolean
  const [onPremise, setOnPremise] = useState(
    JSON.parse(rootElement.getAttribute("data-onpremise") || null) // Use null as default
  );
  const [ePremise, setePremise] = useState(
    JSON.parse(rootElement.getAttribute("data-epremise") || null) // Use null as default
  );

  const [selectedStateData, setSelectedStateData] = useState({
    state: "",
    retailers: [],
  });

  // Store brand_id and country_iso2_code from data attributes
  const [brandId, setBrandId] = useState(
    rootElement.getAttribute("data-brand-id") || ""
  ); // Default to empty string if not found
  const [countryIso2Code, setCountryIso2Code] = useState(
    rootElement.getAttribute("data-country-iso2") || ""
  );

  const [siteId, setSiteId] = useState(
    rootElement.getAttribute("data-site-id") || ""
  ); // Default to empty string if not found

  const goToNextScreen = (product, stateData, actionType) => {
    if (actionType === "findNearYou") {
      setCurrentScreen(5); // Advance to Screen5 when "Find Near You" is clicked
      return;
    }

    if (currentScreen === 1 && marketProductCode) {
      setCurrentScreen(3); // Directly go to Screen3
    } else {
      if (stateData) {
        setSelectedStateData(stateData);
      }
      setCurrentScreen(currentScreen + 1); // Default flow: continue to the next screen
    }

    // Check if 'product' is a valid object with expected properties
    const isValidProduct =
      product && typeof product === "object" && product.market_product_code;

    if (isValidProduct) {
      setSelectedProduct(product);
      setMarketProductCode(product.market_product_code);
    }
  };

  const resetToFirstScreen = () => {
    setCurrentScreen(1);
    setSelectedProduct(null);
    setMarketProductCode("");
    setSelectedStateData({ state: "", retailers: [] });
  };

  const toggleChatVisibility = () => {
    setIsChatVisible(!isChatVisible);
  };

  // Function to close the chat window
  const closeChat = () => {
    setIsChatVisible(false);
  };

  return (
    <>
      {/* Floating button to toggle chat visibility */}
      <FloatingButton onClick={toggleChatVisibility} />

      {isChatVisible && (
        <div id="bf-chat-window">
          <Header onClose={closeChat} />
          <Body
            ePremise={ePremise}
            onPremise={onPremise}
            currentScreen={currentScreen}
            goToNextScreen={goToNextScreen}
            resetToFirstScreen={resetToFirstScreen}
            marketProductCode={marketProductCode}
            selectedStateData={selectedStateData}
            siteId={siteId}
            brandId={brandId}
            countryIso2Code={countryIso2Code}
          />
          <Footer resetToFirstScreen={resetToFirstScreen} />
        </div>
      )}
    </>
  );
}
